<template lang="pug">
  navigation-menu(:items="items")
</template>

<script>
import NavigationMenu from '../shared/NavigationMenu'
import PERMISSIONS from '../../../constants/permissions'

export default {
  components: {
    NavigationMenu
  },
  data() {
    return {
      items: [
        {
          path: '/online-booking/settings',
          icon: 'web',
          title: 'online_booking.title',
          permission: PERMISSIONS.core.ONLINE_BOOKING_SETTINGS_VIEW,
          hidden: !this.$rfSettings().calendar
        },
        {
          path: '/online-booking/advanced',
          icon: 'tune',
          title: 'online_booking.advanced_settings_heading',
          permission: PERMISSIONS.core.ONLINE_BOOKING_SETTINGS_VIEW
        },
        {
          path: '/online-booking/trackers',
          icon: 'file-chart-outline',
          title: 'online_booking.trackers_settings_heading',
          permission: PERMISSIONS.core.ONLINE_BOOKING_SETTINGS_VIEW
        }
      ]
    }
  }
}
</script>
